import React from 'react';
import { useRef, useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from './context/AuthContext';
import "./SignUp.css"
import { Link } from 'react-router-dom/cjs/react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css'
import "firebase/compat/firestore";
import "firebase/compat/auth";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { BsGoogle } from "react-icons/bs"
import { IoLogoGithub } from "react-icons/io"
import { FaFacebookF } from "react-icons/fa"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { provider, auth } from './Firebase/Firebase';
import { GithubAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { FacebookAuthProvider } from 'firebase/auth';
import { toast } from 'react-toastify';
import firebase from 'firebase/compat/app';
import 'react-toastify/dist/ReactToastify.css';

export default function SignUp({ handleclosemodal }) {
    const usernameRef = useRef()
    const emailRef = useRef()
    const passwordRef = useRef()
    const passwordConfirmRef = useRef()
    const { signUp } = useAuth();
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false);
    const notifylogin = () => {
        toast.success('Welcome to mete & design !!!', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    async function handleSubmit(e) {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true); // This will show validation errors on form fields
            return; // Exit the function if the form is not valid
        }

        // If the form is valid, continue with the sign-up process
        setValidated(false); // Reset the validation state


        if (passwordRef.current.value !== passwordConfirmRef.current.value) {
            return setError('Passwords do not match');
        }

        try {
            setError('')
            setLoading(true)
            await signUp(emailRef.current.value, passwordRef.current.value, usernameRef.current.value)

            handleclosemodal();
            notifylogin();
        } catch {
            setError('Failed to create an account')
        }
        setLoading(false)


    }

    const handleGoogle = async () => {
        try {

            const authResult = await auth.signInWithPopup(provider);
            const user = authResult.user;

            // Check if the user exists in the "users" collection
            const userRef = firebase.firestore().collection('users').doc(user.uid);
            const userDoc = await userRef.get();

            if (!userDoc.exists) {

                // If the user does not exist, create a document in the "users" collection with the user's information
                let photoURL = user.photoURL;

                // If the user signs up with Google and the photoURL contains a Google Drive link, modify it to get the direct image link
                if (user.providerData[0]?.providerId === 'google.com' && user.photoURL.includes('drive.google.com')) {
                    const fileId = user.photoURL.split('/')[5];
                    photoURL = `http://localhost:4000/fetch-image?id=${fileId}`;
                } else {
                    // If the user signs up with Google and the photoURL is a direct image link, upload the image to Firebase Storage
                    const response = await fetch(user.photoURL);
                    const blob = await response.blob();
                    const storageRef = firebase.storage().ref().child(`profile_images/${user.uid}/${user.uid}`);
                    await storageRef.put(blob);
                    photoURL = await storageRef.getDownloadURL();
                }
                // If the user does not exist, create a document in the "users" collection with the user's information
                await userRef.set({
                    email: user.email,
                    displayName: user.displayName,
                    photoURL: photoURL,
                    createdAt: new Date(),
                    uid: user.uid,
                    terms: "agreed",
                    phoneNumber: "",
                    subscribed: false,
                    bio: "",
                    country: "",
                });

                handleclosemodal();
                notifylogin();
            } else {
                setError('User already exists');
                // Handle the case when the user exists (e.g., display an error message)

            }
        } catch (error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The AuthCredential type that was used.
            const credential = GoogleAuthProvider.credentialFromError(error);
            console.log(errorCode, errorMessage, credential);
            setError('An error occurred while signing in.');
            // Handle other error cases here

        }
    }

    const signInWithGithub = async () => {

        try {
            const result = await auth.signInWithPopup(new GithubAuthProvider());
            // The signed-in user info.
            const user = result.user;
            // This gives you a Github Access Token. You can use it to access the Github API.
            const credential = GithubAuthProvider.credentialFromResult(result);
            const accessToken = credential.accessToken;
            console.log(user, accessToken);

            // Create a document in the "users" collection with the user's information
            await firebase.firestore().collection('users').doc(user.uid).set({
                email: user.email || "",
                displayName: user.displayName || "Unknown",
                photoURL: user.photoURL || "https://drive.google.com/file/d/1WOk1Ecs6iw8ufOgQwBOgwDVIVt1OAJww/view?usp=sharing",
                createdAt: new Date(),
                uid: user.uid,
                terms: "agreed",
                phoneNumber: "",
                subscribed: false,
                bio: "",
                country: "",
            });

            setError('');
            handleclosemodal();
            notifylogin();
        } catch (error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The AuthCredential type that was used.
            const credential = GithubAuthProvider.credentialFromError(error);
            console.log(errorCode, errorMessage, credential);
            setError('User already exists');
            prompt(error);
        }
    }
    const signInWithFacebook = async () => {

        try {
            const result = await auth.signInWithPopup(new FacebookAuthProvider());
            // The signed-in user info.
            const user = result.user;
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            const credential = FacebookAuthProvider.credentialFromResult(result);
            const accessToken = credential.accessToken;
            console.log(user, accessToken);

            // Create a document in the "users" collection with the user's information
            await firebase.firestore().collection('users').doc(user.uid).set({
                email: user.email || "",
                displayName: user.displayName || "Unknown",
                photoURL: user.photoURL || "https://drive.google.com/file/d/1WOk1Ecs6iw8ufOgQwBOgwDVIVt1OAJww/view?usp=sharing",
                createdAt: new Date(),
                uid: user.uid,
                terms: "agreed",
                phoneNumber: "",
                subscribed: false,
                bio: "",
                country: "",
            });

            handleclosemodal();
            notifylogin();
        } catch (error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The AuthCredential type that was used.
            const credential = FacebookAuthProvider.credentialFromError(error);
            console.log(errorCode, errorMessage, credential);
            prompt(error);
        }

    }

  // Combined handler for Google sign-in and notification
  const handleGoogleWithNotification = () => {
    handleGoogle(); // Call the Google sign-in function
    notifylogin(); // Call the notification function
};
    return (
        <>
            <div className='contyBod'>
                <Card className='CardBod'>
                    <Card.Body>
                        <h2 className='text-center mb-4 header'>Create Your Account</h2>

                        {error && <Alert variant="danger">{error}</Alert>}

                        <Form noValidate validated={validated} onSubmit={handleSubmit}>

                            <Form.Group className="mb-3" controlId="formGroupName">
                                <FloatingLabel
                                    controlId="floatingInput"
                                    label="Username"
                                    className="mb-3 bg-transparent text-dark"
                                >
                                    <Form.Control type="text" className='formInp' placeholder='Username' ref={usernameRef} required />
                                </FloatingLabel>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupLabel">
                                <FloatingLabel
                                    controlId="floatingInput2"
                                    label="Email Address"
                                    className="mb-3 bg-transparent text-dark"
                                >
                                    <Form.Control type="email" className='formInp' placeholder='Email Address' ref={emailRef} required />
                                </FloatingLabel>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupHeading">
                                <FloatingLabel
                                    controlId="floatingInput3"
                                    label="Password"
                                    className="mb-3 bg-transparent text-dark"
                                >
                                    <Form.Control type="password" className='formInp' placeholder='Password' ref={passwordRef} required />
                                </FloatingLabel>
                                <Form.Text id="passwordHelpBlock" muted className='text-start'>
                                    A strong password is: At least 12 characters long but 14 or more is better.
                                    A combination of uppercase letters, lowercase letters, numbers, and symbols.
                                </Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupHeading">
                                <FloatingLabel
                                    controlId="floatingInput4"
                                    label="Confirm Password"
                                    className="mb-3 bg-transparent text-dark"
                                >
                                    <Form.Control type="password" className='formInp' placeholder='Confirm Password' ref={passwordConfirmRef} required />
                                </FloatingLabel>

                            </Form.Group>

                            {/* agreement */}
                            <Form.Group id="agree">
                                <input className="form-check-input  shadow-none " disabled={loading} type="checkbox" value="" id="flexCheckDefault" required />
                                <Form.Text className="form-check-label accept ">
                                    I have read and accepted the <Link to="/termsOfService" className="link_item">Terms of Service</Link> and Privacy Policy.
                                </Form.Text>
                            </Form.Group>
                            <Form.Text className=' already'>
                                {/* <p className=' already'>Already a member?<Link to="/signIn" className="link_item"> Sign In </Link></p> */}
                            </Form.Text>
                            <div className="W-100 d-flex  justify-content-center ">



                                <Button disabled={loading} type='submit' className='btn outl  ' notifylogin={notifylogin}>Create Account</Button>
                            </div>


                        </Form>
                        <div>
                            <div className=' already'>
                                <p>Or create account with</p>
                            </div>
                            <div className='butHold'>
                                <Row>
                                    <Col className='padi'>
                                        <Button disabled={loading} type='submit' className='btn SocialIn ' onClick={handleGoogleWithNotification}><BsGoogle /> Google</Button>
                                    </Col>
                                    <Col className='padi'>
                                        <Button disabled={loading} type='submit' className='btn SocialIn  ' onClick={signInWithGithub}><IoLogoGithub /> Github</Button>
                                    </Col>
                                    <Col className='padi'>
                                        <Button disabled={loading} type='submit' className='btn SocialIn  ' onClick={signInWithFacebook}><FaFacebookF /> Facebook</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                    </Card.Body>
                </Card>

            </div>
        </>
    );
};

